import { EventBus } from '../../helpers';

type UpdateSingleBillEventBusEvents = {
  requestSingleBillCreate: [];
  requestSingleBillUpdate: [];
};

class UpdateSingleBillEventBusEventBus extends EventBus<UpdateSingleBillEventBusEvents> {}

export const updateSingleBillEventBusEventBus = new UpdateSingleBillEventBusEventBus();
